




import {Component, Vue} from 'vue-property-decorator'
import InputSelect from '@/components/lib/InputSelect.vue'
import {IOption} from '@/components/lib/models'
import {ICurrencyData} from '@/entities'

@Component({
  components: {
    InputSelect
  }
})
export default class CurrencyChanger extends Vue {

  get haveChoice(): boolean {
    return this.currencies.length > 1
  }

  get currencies(): ICurrencyData[] {
    return this.$storage.getters.getAllCurrencies()
  }

  get options(): IOption<number>[] {
    return this.currencies.map((currency: ICurrencyData) => ({
      name: currency.name,
      value: currency.id
    }))
  }

  get current(): number | undefined {
    return this.$storage.getters.getCurrentCurrency().id
  }

  set current(value: number | undefined) {
    let currency = this.currencies.find(
      (currency: ICurrencyData) => currency.id === value
    )
    if (currency) this.$storage.actions.setCurrency(currency)
  }

}
